import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-quick_add_modal_add_to_bag_button-click';
/**
 * quick add modal add to bag button
 */
export function trackCoreCollectionsQuickAddModalAddToBagButtonClick(productToken, productBasedCollectionToken, Request_Id_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            productToken,
            productBasedCollectionToken,
            Request_Id_string,
        },
    });
}
